const Row = ({className, label, price, formatCurrency}) => (
    <tr className={className}>
        <td colSpan={price === null ? 2 : 1}>{label}</td>
        {price === null ? null : (
            <td className="price">
                {formatCurrency(price)}
            </td>
        )}
    </tr>
);

Row.defaultProps = {
    price: null,
};

export default Row;
